import React from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Pricing() {
  const benefits = ['Libro completo en formato PDF', 'Acceso instantáneo tras la compra'];
  return <section id="precio" className="py-24 bg-gradient-to-b from-[#112240] to-[#0A192F]" data-id="element-97">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-98">
        <motion.div className="max-w-lg mx-auto bg-[#0A192F] rounded-3xl border border-[#D4AF37]/30 p-8 md:p-12 shadow-[0_0_50px_rgba(212,175,55,0.1)] relative overflow-hidden" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-99">
          {/* Subtle top glow */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent opacity-50" data-id="element-100"></div>

          <div className="text-center mb-8" data-id="element-101">
            <h2 className="text-3xl font-['Playfair_Display'] text-[#FFF8F0] mb-2" data-id="element-102">
              Inversión en tu Paz Mental
            </h2>
            <p className="text-[#A8B2D1] font-['Inter']" data-id="element-103">
              Un solo pago, acceso para siempre.
            </p>
          </div>

          <div className="flex justify-center items-baseline mb-8" data-id="element-104">
            <span className="text-6xl font-['Playfair_Display'] text-[#D4AF37] font-bold" data-id="element-105">
              14.99
            </span>
            <span className="text-[#A8B2D1] font-['Inter'] ml-2" data-id="element-106">USD</span>
          </div>

          <ul className="space-y-4 mb-10" data-id="element-107">
            {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-108">
                <CheckIcon className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" data-id="element-109" />
                <span className="text-[#FFF8F0] font-['Inter']" data-id="element-110">{benefit}</span>
              </li>)}
          </ul>

          <a href="https://templeofpages.com/cart/48626364481779:1?locale=es" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'El Budismo Hoy 2026',
              content_type: 'product',
              value: 14.99,
              currency: 'USD'
            });
          }
        }} className="block w-full bg-[#D4AF37] text-white py-4 rounded-xl font-semibold font-['Inter'] text-lg hover:bg-[#E8C84A] transition-all shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] transform hover:-translate-y-1 text-center" data-id="element-111">
            Descargar El Libro Ahora
          </a>

          <p className="text-center text-[#8892B0] text-sm font-['Inter'] mt-6" data-id="element-112">
            Pago 100% seguro y encriptado.
          </p>
        </motion.div>
      </div>
    </section>;
}